<template>
  <div>
    <v-card
        height="350"
        class="rounded-lg white" flat
    >
      <v-card-title class=" mr-3  secondary--text" style="font-size: medium; margin-top: -10px" >
        <v-img class="ml-3" src="/img/icons/docs.svg" max-width="25" max-height="25"></v-img>
        لیست اسـناد<v-spacer></v-spacer>
        <v-tooltip right v-if="summary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" fab icon class="mr-3" :href="'/report/lastSanadList?openTab=' + tab"
                   target="_blank">
              <v-img class="" src="/img/icons/info_circle.svg" max-width="23"></v-img>
            </v-btn>
          </template>
          مشاهده کامل
        </v-tooltip>
        <v-tooltip right color="secondary" >
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" fab icon class="" href="sanad/form">
              <v-img class="" src="/img/icons/plus_doc.svg" max-width="26"></v-img>
            </v-btn>
          </template>
          ثبت سند جدید
        </v-tooltip>
      </v-card-title >
      <v-tabs style="margin-top: -10px" class="rounded-lg white--text" :value="(summary)?tab:openTab" v-model="tab"
              background-color="lightSecondary" color="primary">
        <v-tab class="white--text mr-5" active-class=" secondary mr-5">
          <span >قطعی</span>
        </v-tab>
        <v-tab class="white--text " active-class=" secondary">
          <span>غیر قطعی</span>
        </v-tab>
        <v-tab class="white--text " active-class=" secondary">
          <span>خالی</span>
        </v-tab>
        <v-tab class="white--text " active-class=" secondary">
          <span class>نامتوازن</span>
        </v-tab>
        <v-tab-item class="pt-4">
          <v-simple-table class="mr-2 ml-2 rounded-b-lg">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">
                  شماره عطف
                </th>
                <th class="text-center">
                  تاریخ
                </th>
                <th class="text-center">
                  شرح سند
                </th>
                <th class="text-center">
                  بدهکار
                </th>
                <th class="text-center">
                  بستانکار
                </th>
                <th class="text-center">
                  وضعیت
                </th>
                <th class="text-center">
                  مشاهده
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="sanad in defined_sanads">
                <td class="text-center">{{sanad.local_id}}</td>
                <td class="text-center">{{sanad.date}}</td>
                <td class="text-center">{{sanad.explanation}}</td>
                <td class="text-center">{{sanad.bed | toMoney(0)}}</td>
                <td class="text-center">{{sanad.bes | toMoney(0)}}</td>
                <td class="text-center error--text " v-if="sanad.bed == 0 && sanad.bes == 0">خالی</td>
                <td class="text-center success--text " v-else-if="sanad.bed == sanad.bes">متوازن</td>
                <td class="text-center warning--text " v-else="sanad.bed != sanad.bes">نا متوازن</td>
                <td class="text-center">
                  <v-tooltip right >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="$router.push(to(sanad))" depressed icon class="info--text" v-bind="attrs" v-on="on">
                        <v-img class="" src="/img/icons/doc_seen.svg" max-width="23"></v-img>
                      </v-btn>
                    </template>
                    جزییات سند
                  </v-tooltip>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-tab-item>








        <v-tab-item class="pt-4">
          <v-simple-table class="mr-2 ml-2 rounded-b-lg">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">
                  شماره عطف
                </th>
                <th class="text-center">
                  تاریخ
                </th>
                <th class="text-center">
                  شرح سند
                </th>
                <th class="text-center">
                  بدهکار
                </th>
                <th class="text-center">
                  بستانکار
                </th>
                <th class="text-center">
                  وضعیت
                </th>
                <th class="text-center">
                  مشاهده
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="sanad in un_defined_sanads">
                <td class="text-center">{{sanad.local_id}}</td>
                <td class="text-center">{{sanad.date}}</td>
                <td class="text-center">{{sanad.explanation}}</td>
                <td class="text-center">{{sanad.bed | toMoney(0)}}</td>
                <td class="text-center">{{sanad.bes | toMoney(0)}}</td>
                <td class="text-center error--text " v-if="sanad.bed == 0 && sanad.bes == 0">خالی</td>
                <td class="text-center success--text " v-else-if="sanad.bed == sanad.bes">متوازن</td>
                <td class="text-center warning--text " v-else="sanad.bed != sanad.bes">نا متوازن</td>
                <td class="text-center">
                  <v-tooltip right >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="$router.push(to(sanad))" depressed icon class="info--text" v-bind="attrs" v-on="on">
                        <v-img class="" src="/img/icons/doc_seen.svg" max-width="23"></v-img>
                      </v-btn>
                    </template>
                    جزییات سند
                  </v-tooltip>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-tab-item>





        <v-tab-item class="pt-4">
          <v-simple-table class="mr-2 ml-2 rounded-b-lg">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">
                  شماره عطف
                </th>
                <th class="text-center">
                  تاریخ
                </th>
                <th class="text-center">
                  شرح سند
                </th>
                <th class="text-center">
                  بدهکار
                </th>
                <th class="text-center">
                  بستانکار
                </th>

                <th class="text-center">
                  قطعی
                </th>
                <th class="text-center">
                  مشاهده
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="sanad in blank_sanads" >
                <td class="text-center">{{sanad.local_id}}</td>
                <td class="text-center">{{sanad.date}}</td>
                <td class="text-center">{{sanad.explanation}}</td>
                <td class="text-center">{{sanad.bed | toMoney(0)}}</td>
                <td class="text-center">{{sanad.bes | toMoney(0)}}</td>
                <td class="text-center error--text ">
                  <v-icon class="success--text" v-if="sanad.is_defined">fa-check</v-icon>
                  <v-icon class="error--text" v-else>fa-times</v-icon>
                </td>
                <td class="text-center">
                  <v-tooltip right >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="$router.push(to(sanad))" depressed icon class="info--text" v-bind="attrs" v-on="on">
                        <v-img class="" src="/img/icons/doc_seen.svg" max-width="23"></v-img>
                      </v-btn>
                    </template>
                    جزییات سند
                  </v-tooltip>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>

        </v-tab-item>
        <v-tab-item class="pt-4">
          <v-simple-table class="mr-2 ml-2 rounded-b-lg">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">
                  شماره عطف
                </th>
                <th class="text-center">
                  تاریخ
                </th>
                <th class="text-center">
                  شرح سند
                </th>
                <th class="text-center">
                  بدهکار
                </th>
                <th class="text-center">
                  بستانکار
                </th>
                <th class="text-center">
                  قطعی
                </th>
                <th class="text-center">
                  مشاهده
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="sanad in un_balance_sanads" >
                <td class="text-center">{{sanad.local_id}}</td>
                <td class="text-center">{{sanad.date}}</td>
                <td class="text-center">{{sanad.explanation}}</td>
                <td class="text-center">{{sanad.bed | toMoney(0)}}</td>
                <td class="text-center">{{sanad.bes | toMoney(0)}}</td>
                <td class="text-center error--text ">
                  <v-icon class="success--text" v-if="sanad.is_defined">fa-check</v-icon>
                  <v-icon class="error--text" v-else>fa-times</v-icon>
                </td>
                <td class="text-center">
                  <v-tooltip right >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="$router.push(to(sanad))" depressed icon class="info--text" v-bind="attrs" v-on="on">
                        <v-img class="" src="/img/icons/doc_seen.svg" max-width="23"></v-img>
                      </v-btn>
                    </template>
                    جزییات سند
                  </v-tooltip>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>

        </v-tab-item>
      </v-tabs>

    </v-card>
  </div>
</template>
<script>


export default {
  name: "SanadListTabs",
  components: {
  },
  props: {
    id: {},
    summary: {
      default: false
    },
  },
  data() {
    return {
      sanads: null,
      tab: null,
      defined_sanads: [],
      un_defined_sanads: [],
      blank_sanads: [],
      un_balance_sanads: [],
    }
  },
  mounted() {
    if (!this.summary){
      this.tab = this.openTab
    }

    this.getData()
  },
  computed: {
    openTab() {
      return parseInt(this.$route.query.openTab)
    },
  },
  methods: {
    getData(){
      let api_url = 'reports/lists/sanads?limit=20&offset=0&search='
      if (!this.summary){api_url = 'reports/lists/sanads?limit=100&offset=0&search='}
      this.request({
        url: this.endpoint(api_url),
        method: "get",
        success: data => {
          this.sanads = data.results
          let counter = 0
          for (let sanad of this.sanads) {
            if (sanad.is_defined && counter < 5) {
              this.defined_sanads.push(sanad)
              if (this.summary){counter += 1}
            }
          }
          counter = 0
          for (let sanad of this.sanads) {
            if (!sanad.is_defined && counter < 5) {
              this.un_defined_sanads.push(sanad)
              if (this.summary){counter += 1}
            }
          }
          counter = 0
          for (let sanad of this.sanads) {
            if (sanad.bed == 0 && sanad.bes == 0 && counter < 5) {
              this.blank_sanads.push(sanad)
              if (this.summary){counter += 1}
            }
          }
          counter = 0
          for (let sanad of this.sanads) {
            if (sanad.bed != sanad.bes && counter < 5) {
              this.un_balance_sanads.push(sanad)
              if (this.summary){counter += 1}
            }
          }
        },
      })
    },
    to(item) {
      return {
        name: "SanadForm",
        params: {
          id: item.id,
        },
      };
    },

  },

}
</script>

<style scoped lang="scss"></style>

